// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

M.View = M.View || {};
M.View.ProductDetails = M.View.ProductDetails || {};

/**
 * View for delivery estimate panel.
 */
M.View.ProductDetails.EstimatePanel = Backbone.View.extend({
  template: M.Template.ProductDetails.EstimatePanel,

  events: {
    'click .moreDeliveryOptions': 'openEstimatorDialog'
  },

  initialize: function() {
    var that = this;

    // Get the response
    M.Model.DeliveryEstimator.Api.deliveryEstimate(
      this.model,
      function(response) {
        that.model.set(response[0]);
        that.render();
      }
    );

  },

  render: function() {
    this.$el = this.$el || $(this.el);
    this.$el.html(
        this.template({
            model: this.model
        })
    );

    // Bind tracking events after the estimator panel is rendered
    M.createInstrumentedElements(M.GA.TRACK_EVENT_CATEGORY.PDP);

    return this;
  },

  openEstimatorDialog: function() {
    var estimatorTool = new M.View.Order.DeliveryEstimatorTool({
      model: this.model,
      hasShippingMethodsPicker: true
    });
    var $estimatorTool = estimatorTool.render().$el;

    // HACK: jQuery UI autofocuses the first input in a dialog, which
    // would bring up the date picker. We disable the datepicker input here and
    // reenable it in the dialog's open callback.
    // TODO: Fix this when we upgrade to jQuery UI 1.10.
    $estimatorTool.find('.datePicker').attr('disabled', 'disabled');

    $estimatorTool.dialog({
      width: 600,
      title: 'estimate your delivery date',
      open: function() {
        $estimatorTool.find('.datePicker').removeAttr('disabled');
      }
    });
  }
});
